import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {INDRABFMDataStorageService} from '@ibe.services/bfm-data-storage.indra.service';
import {Action} from '@ngrx/store';
import {Observable, of, throwError} from 'rxjs';
import * as fromStore from '../_store';
import {catchError, concatMap, map, switchMap, tap} from 'rxjs/operators';
import {INDRABookedTripDetails} from '@ibe.models/booked-trip-details.indra.model.lib';
import {DocumentTypeIndraService} from '@ibe.services/document-type-indra.service';
import {FrequentFlyerIndraService} from '@ibe.services/frequent-flyer-indra.service';
import {SavePassenger, SaveNewPassenger} from './passengers-details.actions';
import {PassengerPctcService} from '@ibe.services/passenger-pctc.service';
import {PassengerApisService} from '@ibe.services/passenger-apis.service';
import {PassengerFqtvService} from '@ibe.services/passenger-fqtv.service';
import {PassengerContactsService} from '@ibe.services/passenger-contacts.service';
import {PassengerService} from '@ibe.services/passenger.service';
import * as _ from 'lodash';
import { TimeoutSvcService } from '@ibe.services/timeout-svc.service';
import { INDRAParallelService } from '@ibe.services/parallel.indra.service';

@Injectable()
export class PassengersDetailsEffects {

	constructor(
		private actions$: Actions,
		private dataStorageService: INDRABFMDataStorageService,
		private documentService: DocumentTypeIndraService,
		private frequentFlyerService: FrequentFlyerIndraService,
		private passengerPctcService: PassengerPctcService,
		private passengerApisService: PassengerApisService,
		private passengerFqtvService: PassengerFqtvService,
		private passengerContactsService: PassengerContactsService,
		private passengerService: PassengerService,
		private timeoutSvc: TimeoutSvcService,
		private parallelService: INDRAParallelService,
	) { }

	@Effect()
	loadBookedTrip$: Observable<Action> = this.actions$.pipe(
		ofType(fromStore.ActionTypes.LOADING),
		switchMap(() =>
			of(this.dataStorageService.INDRA_getActiveBookedTrip())
		),
		map((data: INDRABookedTripDetails) =>
			new fromStore.PutBookedTripPassengersDetailsAction(data)
		)
	);

	@Effect()
	loadDocumentTypes$: Observable<Action> = this.actions$.pipe(
		ofType(fromStore.ActionTypes.LOAD_DOCUMENT_TYPES),
		switchMap(() => this.documentService.getDocumentTypes()),
		map((data: any) => new fromStore.LoadDocumentTypesSuccess(data))
	);

	@Effect()
	loadFrequentFlyerPrograms$: Observable<Action> = this.actions$.pipe(
		ofType(fromStore.ActionTypes.LOAD_FREQUENT_FLYER_PROGRAMS),
		switchMap(() => this.frequentFlyerService.getFrequentFlyerPrograms()),
		map((data: any) => new fromStore.LoadFrequentFlyerProgramsSuccess(data))
	);

	@Effect()
	loadCompanionList$: Observable<Action> = this.actions$.pipe(
		ofType(fromStore.ActionTypes.LOAD_COMPANION_LIST),
		switchMap(() => this.frequentFlyerService.getCompanionList()),
		map((data: any) => new fromStore.LoadFrequentFlyerProgramsSuccess(data))
	);

	@Effect()
	savePassenger$: Observable<Action> = this.actions$.pipe(
		ofType(fromStore.ActionTypes.SAVE_PASSENGER),
		map((action: SavePassenger) => ({data: action.payload, pnr: action.pnr, passenger_id: action.passenger_id})),
		switchMap(request => this.passengerService.savePassenger(request.data, request.pnr, request.passenger_id).pipe(
			concatMap((res: any) => { // TODO [Lucas Santos]: THIS NEED TO BE VERIFIED IN HTTP_INTERCEPTOR
				if (!_.isNil(res)
					&& _.has(res, 'status')
					&& _.has(res, 'errors')) {
					const {errors, status} = res;
					if (Object.is(+status, 200) && _.isEmpty(errors)) {
						return of(res);
					} else {
						return throwError(errors);
					}
				}
				return of(res);
			}),
			map(resp => new fromStore.SavePassengerSuccess({ rq: request, res: resp })),
			catchError((errors: any) => of(new fromStore.SavePassengerErrors(errors)))
		))
	);
	
	@Effect()
	saveNewPassenger$: Observable<Action> = this.actions$.pipe(
		ofType(fromStore.ActionTypes.SAVE_NEW_PASSENGER),
		map((action: SaveNewPassenger) => ({data: action.payload, passenger_id: action.passenger_id, passenger_type: action.passenger_type})),
		switchMap(request => {
			this.parallelService.INDRA_setTriggerCreatePassenger(true);

			return this.passengerService.saveNewPassenger(request.data, request.passenger_id, request.passenger_type)
				.pipe(
					concatMap((res: any) => { 
						if (!_.isNil(res)
							&& _.has(res, 'status')
							&& _.has(res, 'errors')) {
							this.timeoutSvc.isOtherAPILoading$.next(false);

							const {errors, status} = res;
							if (Object.is(+status, 200) && _.isEmpty(errors)) {
								return of(res);
							} else {
								return throwError(errors);
							}
						}
						/*
						if (!_.isNil(res)
							&& _.has(res, 'errors')) {
							const {errors, status} = res;
							if (_.isEmpty(errors)) {
								return of(res);
							} else {
								return throwError(errors);
							}
						}
						return of(res);
						*/
					}),
					map(resp => new fromStore.SavePassengerSuccess({ rq: request, res: resp })),
					catchError((errors: any) => {
						this.timeoutSvc.isOtherAPILoading$.next(false);
						return of(new fromStore.SavePassengerErrors(errors))
					})
			);
		})
	);

	@Effect({dispatch: false})
	savePassengerResult$: Observable<Action> = this.actions$.pipe(
		ofType(fromStore.ActionTypes.SAVE_PASSENGER_SUCCESS, fromStore.ActionTypes.SAVE_PASSENGER_ERRORS),
		tap(action => {
			this.parallelService.INDRA_setTriggerCreatePassenger(false);
			this.parallelService.INDRA_setIsPassengerCreated(true);
		})
	);
}
